<section class="scr-page">
  <tp-page-header
    title="Nueva orden de trabajo"
    subtitle="Elegí el cliente, el domicilio y el trabajo a realizar"
  ></tp-page-header>

  <form [formGroup]="workloadForm" class="workload scr-card scr-card--padded">
    <mat-stepper linear #stepper>
      <mat-step>
        <ng-template matStepLabel>Cliente</ng-template>
        <app-client></app-client>
        <div class="section-button section-button--end">
          <button type="button" title="Siguiente" (click)="goStepAddress(stepper)" mat-flat-button class="scr-btn-primary">
            Siguiente
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          </button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Domicilio</ng-template>
        <app-step-address [formGroup]="workloadForm"></app-step-address>
        <div class="section-button">
          <button type="button" title="Anterior" mat-stroked-button matStepperPrevious class="scr-btn-secondary">
            <mat-icon>arrow_back</mat-icon>
            Anterior
          </button>
          <button type="button" title="Siguiente" (click)="goStepWorkTask(stepper)" mat-flat-button class="scr-btn-primary">
            Siguiente
            <mat-icon iconPositionEnd>arrow_forward</mat-icon>
          </button>
        </div>
      </mat-step>
      <mat-step>
        <ng-template matStepLabel>Orden de trabajo</ng-template>
        <app-work-task [form]="workloadForm" (disableSubmit)="checkDisabledFinish()" [coordinates]="coordinates" [fromCMR]="fromCMR"></app-work-task>
        <div class="section-button">
          <button type="button" mat-stroked-button matStepperPrevious class="scr-btn-secondary">
            <mat-icon>arrow_back</mat-icon>
            Atrás
          </button>
          <button mat-flat-button (click)="submitWorkload(stepper)"
            type="button"
            class="scr-btn-primary"
            [disabled]="disableSubmit">Finalizar</button>
        </div>
      </mat-step>
    </mat-stepper>
  </form>
</section>
